document.addEventListener('DOMContentLoaded', () => {
  const form = document.querySelector('form[action*="contact"]');
  const message = document.querySelector('.email-signup__message-text');
  const container = document.querySelector('.email-signup__message--success');

  if (!form || !message || !container) return;

  container.setAttribute('role', 'status');
  container.setAttribute('aria-live', 'polite');
  container.setAttribute('aria-atomic', 'true');

  form.addEventListener('submit', () => {
    // Esperamos a que Shopify haga lo suyo
    setTimeout(() => {
      const text = message.textContent.trim();
      if (!text) return;

      // 🔥 Forzar cambio REAL para NVDA
      message.textContent = '';
      setTimeout(() => {
        message.textContent = text;
      }, 50);
    }, 300);
  });
});
